document.addEventListener('DOMContentLoaded', function () {
  initCollapsibles(document);
  observeQuickView();
});

function initCollapsibles(scope) {
  let triggers = scope.querySelectorAll(
    '.product_full_description .collapsible-trigger'
  );

  triggers.forEach(function (trigger) {
    if (trigger.dataset.collapsibleInit) return;
    trigger.dataset.collapsibleInit = 'true';

    trigger.addEventListener('click', function () {
      let block = trigger.closest('.product-collapsible-block');
      let isOpen = block.classList.contains('is-open');

      let container = trigger.closest('.product_full_description');
      let allBlocks = container.querySelectorAll('.product-collapsible-block');
      allBlocks.forEach(function (b) {
        b.classList.remove('is-open');
      });

      if (!isOpen) {
        block.classList.add('is-open');

        setTimeout(function () {
          let scrollContainer = trigger.closest('.quick-view-popup, .modal, [data-quick-view]');

          if (scrollContainer) {
            let containerTop = scrollContainer.getBoundingClientRect().top;
            let triggerTop = trigger.getBoundingClientRect().top;
            let offset = 20;
            scrollContainer.scrollTo({
              top: scrollContainer.scrollTop + (triggerTop - containerTop) - offset,
              behavior: 'smooth'
            });
          } else {
            let triggerTop = trigger.getBoundingClientRect().top + window.scrollY;
            let offset = window.innerWidth > 768 ? 200 : 400;
            window.scrollTo({
              top: triggerTop - offset,
              behavior: 'smooth'
            });
          }
        }, 200);
      }
    });
  });

  let firstBlock = scope.querySelector(
    '.product_full_description .product-collapsible-block'
  );
  if (firstBlock) {
    firstBlock.classList.add('is-open');
  }
}

function observeQuickView() {
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;

        if (node.querySelector && node.querySelector('.product_full_description')) {
          initCollapsibles(node);
        }

        if (node.classList && node.classList.contains('product_full_description')) {
          initCollapsibles(node.parentElement || node);
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}